import React from 'react'
import BaseIcon from 'react-icon-base'

import { EColors } from 'app/constants/colors'

const Pulse = props => {
  return (
    <BaseIcon width="221" height="126" viewBox="0 0 221 126" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient x1="11.854%" y1="43.405%" x2="103.129%" y2="43.405%" id="32k8f7yr3a">
          <stop stopColor={EColors.BLUE} offset="0%" />
          <stop stopColor={EColors.BLUE} offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          strokeOpacity=".11"
          stroke="#087ACB"
          d="M.844 31.639h220M.844 62.639h220M.844.639h220M.844 124.639h220M.844 93.639h220"
        />
        <path
          d="M41.507 62.25H69.41a13 13 0 0 0 12.732-10.37l3.245-15.72a9.602 9.602 0 0 1 9.404-7.66 9.402 9.402 0 0 1 9.245 7.691l9.574 51.722a9.493 9.493 0 0 0 9.334 7.765c4.642 0 8.69-3.157 9.82-7.659l4.001-15.934a13 13 0 0 1 12.609-9.834h28.59"
          stroke="url(#32k8f7yr3a)"
          strokeWidth="5.4"
          strokeLinecap="round"
          transform="rotate(-180 110.158 62.158)"
        />
      </g>
    </BaseIcon>
  )
}

export default Pulse
